export function initialize() {
    $(window).scroll(function() {
        if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
            $('#return-to-top').fadeIn(200);    // Fade in the arrow
        } else {
            $('#return-to-top').fadeOut(200);   // Else fade out the arrow
        }
    });

    $('#return-to-top').click(function() {      // When arrow is clicked
        $('body,html').animate({
            scrollTop : 0                       // Scroll to top of body
        }, 500);
    });

    $('.scroll-me a').bind('click', function (event) {
        var $anchor = $(this);
        $('body,html').animate({
            scrollTop : $($anchor.attr('href')).offset().top - 85                      // Scroll to top of body
        }, 500);
        event.preventDefault();
    });
}

export default {

};
